// TranscriptSync Vuex Store Module
import authModule from './modules/auth'
import integrationsModule from './modules/integrations'

export default {
  namespaced: true,
  modules: {
    auth: authModule,
    integrations: integrationsModule
  },
  
  state: () => ({
    isInitialized: false,
    currentPage: null
  }),
  
  getters: {
    isInitialized: state => state.isInitialized,
    currentPage: state => state.currentPage
  },
  
  mutations: {
    SET_INITIALIZED(state, status) {
      state.isInitialized = status
    },
    
    SET_CURRENT_PAGE(state, page) {
      state.currentPage = page
    }
  },
  
  actions: {
    initialize({ commit }, page) {
      commit('SET_INITIALIZED', true)
      commit('SET_CURRENT_PAGE', page)
      
      if (process.env.NODE_ENV === 'development') {
        console.log('[TranscriptSync Store] Initialized for page:', page)
      }
    }
  }
}